import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'toNearestDecimal',
  standalone: true
})
export class ToNearestDecimalPipe implements PipeTransform {
  transform(value: number): number {
    return Math.round(value * 10) / 10;
  }
}
